import React, { Fragment } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Modal from "../../Modal";

class SignUp extends React.Component {
  state = { loading: false, visible: false };

  toggleModal = () => this.setState({ visible: !this.state.visible });

  send = () => {
    const { id, onDone } = this.props;

    this.setState({ loading: true });
    axios.post(`/in_services/${id}/signing`)
      .then(({ data }) => {
        this.setState({ loading: false, visible: false });
        toastr.success(data.message);
        onDone(id, data.record);
      })
      .catch(({ response }) => {
        this.setState({ loading: false });
        if (response && response.data && response.data.message) {
          toastr.success(response.data.message);
        }
      })
    ;
  };

  render() {
    const { visible, loading } = this.state;
    const { disabled } = this.props;

    return (
      <Fragment>
        <button
          disabled={disabled || loading}
          className="btn btn-pink btn-raised btn-long margin-right-five"
          onClick={this.toggleModal}
        >
          {this.props.isSignedUp ? 'SIGNED UP' : 'SIGN UP'}
        </button>

        <Modal visible={visible} onClose={this.toggleModal}>
          <div>
            <h4>
              <center>
                Are you sure you want to sign up for this in-service training?
              </center>
            </h4>
            <button
              className="btn btn-pink btn-block btn-raised"
              disabled={loading}
              onClick={this.send}
            >
              SIGN UP
            </button>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

SignUp.propTypes = {
  id: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  isSignedUp: PropTypes.bool,
  onDone: PropTypes.func.isRequired
};

SignUp.defaultProps = {
  disabled: false
};

export default SignUp;
